export const translations = {
    es: {
      welcome: "Bienvenido a\n 3Devs Solutions",
      subtitle: "Innovación, tecnología y soluciones a medida",
      aboutTitle: "Sobre Nosotros",
      trabajos: "Nuestros Trabajos",
      trabajos_subtitle: "Trabajos que reflejan nuestra pasión por la tecnología",
      mas: "Más",
      servicios: "Servicios",
      aboutTitle: "Sobre Nosotros",
      aboutText1: "En 3 Devs Solutions, transformamos ideas en software a medida, combinando innovación y tecnología para desarrollar soluciones eficientes y adaptadas a cada cliente.",
      aboutText2: "Nos distingue nuestro compromiso con la excelencia y la satisfacción del cliente. Diseñamos productos de alta calidad mediante metodologías ágiles, optimizando tiempos y garantizando entregas puntuales.",
      aboutText3: "Nuestro equipo está formado por profesionales apasionados, enfocados en ofrecer resultados que marquen la diferencia. Priorizamos la comunicación y la adaptación a cada desafío para garantizar el éxito de cada proyecto.",
      aboutText4: "Entendemos que cada negocio es único. Por eso, iniciamos cada desarrollo con un análisis detallado de tus necesidades y objetivos, aplicando tecnología de vanguardia para superar expectativas.",
      teamTitle: "Nuestro Equipo",
      teamSubtitle: "Conoce a los desarrolladores detrás de nuestras soluciones",
      stackTitle: "Stack Tecnológico",
      stackSubtitle: "Tecnologías y herramientas que utilizamos para desarrollar soluciones eficientes.",
      contactTitle: "Contacto",
      followTitle: "Síguenos",
      footerText: "Innovación, tecnología y soluciones a medida",
      copyright: "Todos los derechos reservados.",
      servicios_subtitle: "Ofrecemos soluciones personalizadas para satisfacer tus necesidades tecnológicas",
      desarrollo_web: "Desarrollo Web",
      desarrollo_web_subtitle: "Desarrollo de sitios web modernos, funcionales y optimizados.",
      desarrollo_web_pros: [
        "Accesible desde cualquier dispositivo con internet.",
        "Fácil mantenimiento y escalabilidad.",
        "No requiere instalación en los dispositivos del usuario.",
        "Mayor visibilidad y captación de clientes.",
      ],
      desarrollo_web_contras: [
        "El tiempo de desarrollo varía según el proyecto.",
        "Requiere servidores para su correcto funcionamiento.",
      ],
      desarrollo_escritorio: "Desarrollo de Escritorio",
      desarrollo_escritorio_subtitle: "Software eficiente y personalizado para entornos de escritorio.",
      desarrollo_escritorio_pros: [
        "Funciona sin necesidad de conexión a internet.",
        "Mayor rendimiento en tareas exigentes y especializadas.",
        "No depende de servidores externos para su operatividad.",
        "Mayor control y seguridad en el manejo de datos locales.",
      ],
      desarrollo_escritorio_contras: [
        "Uso limitado al dispositivo en el que se instala.",
        "Puede requerir más recursos del sistema.",
        "Necesita instalación y actualizaciones manuales.",
      ],
      desarrollo_movil: "Desarrollo Móvil",
      desarrollo_movil_subtitle: "Aplicaciones para dispositivos móviles adaptadas a tus necesidades.",
      desarrollo_movil_pros: [
        "Fluidez y optimización para pantallas táctiles.",
        "Mejor uso de los recursos del dispositivo.",
        "Funciona sin conexión en varias tareas.",
        "Mayor seguridad y control de datos.",
      ],
      desarrollo_movil_contras: [
        "Depende del sistema operativo.",
        "Puede consumir más almacenamiento y batería.",
        "Requiere descargas y actualizaciones.",
      ],
      consultar_servicio: "Consultar servicio",
    },
    en: {
      welcome: "Welcome to\n 3Devs Solutions",
      subtitle: "Innovation, technology, and tailored solutions",
      aboutTitle: "About Us",
      trabajos: "Our Work",
      trabajos_subtitle: "Projects that reflect our passion for technology",
      mas: "More",
      servicios: "Services",
      aboutTitle: "About Us",
      aboutText1: "At 3 Devs Solutions, we turn ideas into custom software, combining innovation and technology to develop efficient solutions tailored to each client.",
      aboutText2: "We are distinguished by our commitment to excellence and customer satisfaction. We design high-quality products using agile methodologies, optimizing time and ensuring on-time deliveries.",
      aboutText3: "Our team is made up of passionate professionals focused on delivering results that make a difference. We prioritize communication and adaptability to each challenge to ensure project success.",
      aboutText4: "We understand that every business is unique. That's why we start each development with a detailed analysis of your needs and objectives, applying cutting-edge technology to exceed expectations.",
      teamTitle: "Our Team",
      teamSubtitle: "Meet the developers behind our solutions",
      stackTitle: "Technological Stack",
      stackSubtitle: "Technologies and tools we use to develop efficient solutions.",
      contactTitle: "Contact",
      followTitle: "Follow Us",
      footerText: "Innovation, technology, and tailored solutions",
      copyright: "All rights reserved.",
      servicios_subtitle: "We offer tailored solutions to meet your technological needs",
      desarrollo_web: "Web Development",
      desarrollo_web_subtitle: "Development of modern, functional, and optimized websites.",
      desarrollo_web_pros: [
        "Accessible from any device with internet.",
        "Easy maintenance and scalability.",
        "No installation required on user devices.",
        "Greater visibility and customer acquisition.",
      ],
      desarrollo_web_contras: [
        "Development time varies depending on the project.",
        "Requires servers for proper functioning.",
      ],
      desarrollo_escritorio: "Desktop Development",
      desarrollo_escritorio_subtitle: "Efficient and customized software for desktop environments.",
      desarrollo_escritorio_pros: [
        "Works without an internet connection.",
        "Better performance for demanding and specialized tasks.",
        "Does not depend on external servers for operation.",
        "Greater control and security in handling local data.",
      ],
      desarrollo_escritorio_contras: [
        "Limited to the device where it is installed.",
        "May require more system resources.",
        "Requires manual installation and updates.",
      ],
      desarrollo_movil: "Mobile Development",
      desarrollo_movil_subtitle: "Mobile applications tailored to your needs.",
      desarrollo_movil_pros: [
        "Smooth and optimized for touch screens.",
        "Better use of device resources.",
        "Works offline for various tasks.",
        "Greater security and data control.",
      ],
      desarrollo_movil_contras: [
        "Dependent on the operating system.",
        "May consume more storage and battery.",
        "Requires downloads and updates.",
      ],
      consultar_servicio: "Inquire about the service",
    },
  };
  
  export const developersData = (language) => [
    {
      name: language === "es" ? "Joaquín Mullasano" : "Joaquín Mullasano",
      role: language === "es" ? "Desarrollador de Software" : "Software Developer",
      img: "/img/joa.jpeg",
      info: language === "es" ? [
        "Técnico en Electrónica",
        "Estudiante de tecnicatura universitaria en programación",
        "Experiencia en desarrollo de visión artificial y software",
      ] : [
        "Electronics Technician",
        "Student of University Programming",
        "Experience in artificial vision and software development",
      ],
      linkedin: "https://www.linkedin.com/in/joaquin-mullasano",
      instagram: "https://www.instagram.com/joa.mullasano/",
    },
    {
      name: language === "es" ? "Franco Valverde" : "Franco Valverde",
      role: language === "es" ? "Líder del Equipo de Software" : "Software Team Lead",
      img: "/img/franco.jpeg",
      info: language === "es" ? [
        "Ingeniero en Telecomunicaciones",
        "Técnico en Electrónica",
        "Amplia experiencia en desarrollo de software, sistemas y soluciones tecnológicas",
      ] : [
        "Telecommunications Engineer",
        "Electronics Technician",
        "Extensive experience in software development, systems, and technological solutions",
      ],
      linkedin: "https://www.linkedin.com/in/franco-valverde-b3821b309/",
      instagram: "https://www.instagram.com/francovalver/",
    },
    {
      name: language === "es" ? "Bruno Ballarino" : "Bruno Ballarino",
      role: language === "es" ? "Desarrollador de Software" : "Software Developer",
      img: "/img/Bruno.jpeg",
      info: language === "es" ? [
        "Técnico en Electrónica",
        "Estudiante de tecnicatura superior en desarrollo de software",
        "Experiencia en desarrollo web y soluciones de software",
      ] : [
        "Electronics Technician",
        "Student of Higher Software Development",
        "Experience in web development and software solutions",
      ],
      linkedin: "https://www.linkedin.com/in/bruno-ballarino-8275622b7/",
      instagram: "https://www.instagram.com/ballarinobruno/",
    },
    {
      name: language === "es" ? "Gaston Villalba" : "Gaston Villalba",
      role: language === "es" ? "Desarrollador de Software" : "Software Developer",
      img: "/img/Gaston.jpg",
      info: language === "es" ? [
        "Estudiante de tecnicatura superior en desarrollo de software",
        "Experiencia en desarrollo frontend y desarrollo web",
      ] : [
        "Student of Higher Software Development",
        "Experience in frontend and web development",
      ],
      linkedin: "https://www.linkedin.com/in/gaston-villalba-b70500306/",
      instagram: "https://www.instagram.com/gastonvillalba7373/",
    },
  ];
  
  
  export const trabajos = [
    {
      description: {
        es: "Nuestro equipo desarrolló una plataforma web exclusiva para la asociación LALCEC (San Francisco), diseñada para optimizar la gestión interna de socios y el control de pagos. Esta herramienta es accesible únicamente para los administradores de la institución, asegurando la confidencialidad y seguridad de la información de los miembros.",
        en: "Our team developed an exclusive web platform for the LALCEC association (San Francisco), designed to optimize the internal management of members and payment control. This tool is accessible only to the institution's administrators, ensuring the confidentiality and security of member information."
      }
    }
  ];



  export const serviciosData = {
    es: [
      {
        title: "Desarrollo Web",
        subtitle: "Desarrollo de sitios web modernos, funcionales y optimizados.",
        image: "/img/icono_web.png",
        pros: [
          "Accesible desde cualquier dispositivo con internet.",
          "Fácil mantenimiento y escalabilidad.",
          "No requiere instalación en los dispositivos del usuario.",
          "Mayor visibilidad y captación de clientes."
        ],
        contras: [
          "El tiempo de desarrollo varía según el proyecto.",
          "Requiere servidores para su correcto funcionamiento."
        ]
      },
      {
        title: "Desarrollo de Escritorio",
        subtitle: "Software eficiente y personalizado para entornos de escritorio.",
        image: "/img/icono_escritorio.png",
        pros: [
          "Funciona sin necesidad de conexión a internet.",
          "Mayor rendimiento en tareas exigentes y especializadas.",
          "No depende de servidores externos para su operatividad.",
          "Mayor control y seguridad en el manejo de datos locales."
        ],
        contras: [
          "Uso limitado al dispositivo en el que se instala.",
          "Puede requerir más recursos del sistema.",
          "Necesita instalación y actualizaciones manuales."
        ]
      },
      {
        title: "Desarrollo Móvil",
        subtitle: "Aplicaciones para dispositivos móviles adaptadas a tus necesidades.",
        image: "/img/icono_mov.png",
        pros: [
          "Fluidez y optimización para pantallas táctiles.",
          "Mejor uso de los recursos del dispositivo.",
          "Funciona sin conexión en varias tareas.",
          "Mayor seguridad y control de datos."
        ],
        contras: [
          "Depende del sistema operativo.",
          "Puede consumir más almacenamiento y batería.",
          "Requiere descargas y actualizaciones."
        ]
      }
    ],
    en: [
      {
        title: "Web Development",
        subtitle: "Development of modern, functional, and optimized websites.",
        image: "/img/icono_web.png",
        pros: [
          "Accessible from any device with internet.",
          "Easy maintenance and scalability.",
          "No installation required on user devices.",
          "Greater visibility and customer acquisition."
        ],
        contras: [
          "Development time varies depending on the project.",
          "Requires servers for proper functioning."
        ]
      },
      {
        title: "Desktop Development",
        subtitle: "Efficient and customized software for desktop environments.",
        image: "/img/icono_escritorio.png",
        pros: [
          "Works without an internet connection.",
          "Better performance for demanding and specialized tasks.",
          "Does not depend on external servers for operation.",
          "Greater control and security in handling local data."
        ],
        contras: [
          "Limited to the device where it is installed.",
          "May require more system resources.",
          "Requires manual installation and updates."
        ]
      },
      {
        title: "Mobile Development",
        subtitle: "Mobile applications tailored to your needs.",
        image: "/img/icono_mov.png",
        pros: [
          "Smooth and optimized for touch screens.",
          "Better use of device resources.",
          "Works offline for various tasks.",
          "Greater security and data control."
        ],
        contras: [
          "Dependent on the operating system.",
          "May consume more storage and battery.",
          "Requires downloads and updates."
        ]
      }
    ]
  };







